
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["mindmap-demo-common","mindmap-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__MindMap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/MindMap/index.en.md?type=demo')
};